module.exports = {"audiences":["allMembers"],"experimentVersion":"v1","experimentAllocation":0.01,"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/adsLayout.json
// module id = F+/d
// module chunks = 2